import { Component, OnInit } from '@angular/core';
import { FotosService } from 'src/app/servicios/fotos.service';

@Component({
  selector: 'app-nueva-imagen',
  templateUrl: './nueva-imagen.component.html',
  styleUrls: ['./nueva-imagen.component.scss']
})
export class NuevaImagenComponent implements OnInit {

  public archivo:any;
  public titulo:string;
  public autor:string;

  constructor(private imagenSvc:FotosService) { }

  ngOnInit(): void {
    
  }

  newImagen()
  {
    let foto = {
      titulo:this.titulo,
      creador:this.autor
    };
    console.log(this.archivo);
    
    this.imagenSvc.preAddUpdateCurso(foto, this.archivo);
  }

  handleArchivo(e)
  {
    //comenzar a modificar aca cuando necesite subir mas archivos!!!!!
    //!importanteeeeeeeeeeeeeeeeeeeeeeeeee

    this.archivo = e.target.files[0];
    console.log(this.archivo)
  }
}
